<h2>Connections</h2>
<p>Connect to your third-party cloud services to scan directly from Raven Scanners</p>

<div class="grid-x">
  <div class="cell small-12 large-8 xlarge-6">
    <ul class="menu vertical connections">
      <li *ngFor="let connection of connections" class="padding-vertical-1" data-cy="connection">
        <div class="grid-x grid-padding-x align-justify">
          <div class="shrink cell">
            <rav-icon [name]="connection.icon" class="connections__logo"></rav-icon>
          </div>
          <div class="auto cell">
            <h3>
              {{ connection.name }}
            </h3>
            <div *ngIf="connection.isConnected && scope.hasAccess(scope.scope.ExportServiceWrite)">
              <button
                *ngIf="connection.folder_id && connection.requireFolders && connection.folder_name"
                class="small clear button padding-left-0 padding-top-0 connection__folder-name"
                (click)="selectFolder(connection)"
              >
                <i class="fa fa-edit"></i> {{ connection.folder_name }}
              </button>
              <button
                *ngIf="(!connection.folder_id || !connection.folder_name) && connection.requireFolders"
                class="small alert clear button padding-left-0 padding-top-0"
                (click)="selectFolder(connection)"
              >
                <i class="fa fa-exclamation-triangle"></i> Folder Needed
              </button>
            </div>
          </div>
          <div class="small-12 medium-shrink cell">
            <div *ngIf="connection.isConnected">
              <div class="connections__flex-end">
                <rav-icon [name]="RavIcon.CheckBox" class="connections__icon"></rav-icon>
                <span>Connected</span>
              </div>
              <button
                *ngIf="scope.hasAccess(scope.scope.ExportServiceWrite)"
                class="tiny alert clear button"
                (click)="disconnect(connection)"
              >
                Disconnect
              </button>
            </div>

            <button
              *ngIf="!connection.isConnected && scope.hasAccess(scope.scope.ExportAccountConfigWrite)"
              class="small hollow button connections__flex-end"
              (click)="getAuthUrl(connection)"
            >
              Set Up
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<rav-modal [modalId]="'connection'" modalTitle="Connection">
  <div *ngIf="!hasError">
    <h4>Your {{ currentConnection.name }} has been connected with Raven Cloud .</h4>
    <h5 *ngIf="currentConnection.requireFolders">
      <a data-cy="select-folder" (click)="selectFolder(currentConnection)">Click here</a> to select the
      {{ currentConnection.name }} folder where documents will be sent.
    </h5>
  </div>

  <div class="alert callout" *ngIf="hasError">
    <i class="fa fa-exclamation-triangle"></i>
    {{ connectionError }}
  </div>
</rav-modal>

<rav-modal [modalId]="'selectFolder'">
  <rav-connection-folder-select
    [currentConnectionService]="serviceSubject.asObservable()"
    (navigateBack)="navigateToConnectionsPage()"
    #folder
  ></rav-connection-folder-select>
</rav-modal>

<rav-modal [modalId]="'selectFolderWarning'">
  <div class="alert callout margin-top-2">
    <i class="fa fa-exclamation-triangle"></i>
    You must select a folder.
  </div>
  <h5>
    <a (click)="selectFolder(connectionWithNoFolder)">Click here</a> to select the
    {{ connectionWithNoFolder.name }} folder where documents will be sent.
  </h5>
</rav-modal>

<rav-modal [modalId]="'success'" modalTitle="Connection">
  <div>You can now export documents to your folder {{ folder.selectedFolderName }}</div>
  <button
    type="button"
    data-cy="continue-button"
    class="button primary margin-top-1"
    (click)="navigateToConnectionsPage()"
  >
    Continue
  </button>
</rav-modal>

<rav-modal [modalId]="'SharepointUrl'" modalTitle="Please enter your SharePoint URL">
  <div class="text-center margin-top-2">
    <input #sharepointInput type="text" data-cy="sharepoint-input" />
    <div class="text-left">
      <p class="margin-bottom-0">
        Valid formats:
      </p>
      <p class="margin-bottom-0">
        https://example.sharepoint.com
      </p>
      <p class="margin-bottom-0">
        https://example.sharepoint.com/sites/TeamSiteTesting
      </p>
      <p class="margin-bottom-0">
        https://example.sharepoint.com/sites/TeamSiteTesting/Invoices
      </p>
    </div>
  </div>
  <div>
    <button
      type="button"
      data-cy="sharepoint-confirm"
      class="button primary margin-top-1 margin-right-2"
      (click)="connectService({ sharepoint_site: sharepointInput.value })"
    >
      Confirm
    </button>
    <button
      type="button"
      data-cy="sharepoint-cancel"
      class="button hollow margin-top-1"
      (click)="navigateToConnectionsPage()"
    >
      Cancel
    </button>
  </div>
</rav-modal>

<rav-modal [modalId]="'disconnect-dropbox'">
  <div class="alert callout margin-top-2" data-cy="disconnect-dropbox-message">
    <i class="fa fa-exclamation-triangle"></i>
    Finish Disconnecting Dropbox.
  </div>
  <div class="modal__long-description">
    Raven authentication has been removed. Please visit
    <a href="https://www.dropbox.com/account/connected_apps">https://www.dropbox.com/account/connected_apps</a> to
    finish disconnecting Raven from your Dropbox account.
  </div>
</rav-modal>

<rav-modal [modalId]="'addition-permissions'" modalTitle="">
  <div class="text-center margin-top-2">
    <h3>What access should Raven have to your account?</h3>

    <div class="connection__modal-icons-container">
      <span class="connection__modal-icons">
        <img src="assets/images/raven-bird.png" alt="Raven" />
      </span>
      <span class="connection__modal-icons">
        <rav-icon name="double-arrows"></rav-icon>
      </span>
      <span class="connection__modal-icons connection__modal-icons--dropbox">
        <rav-icon name="{{ currentConnection.icon }}"></rav-icon>
      </span>
    </div>

    <mat-radio-group class="text-left margin-top-2">
      <div class="connection__radio">
        <mat-radio-button
          #appScope
          color="primary"
          name="dropboxScope"
          value="app_folder"
          checked
          data-cy="dropbox-radio1"
        ></mat-radio-button>
        <span class="connection__radio-text">
          App Folder
        </span>
        <p class="connection__radio-description">
          Read and write access only to a Raven folder within your {{ currentConnection.name }} Account via OAuth 2.0.
        </p>
        <p class="connection__radio-description">
          Limits scanning to only the Raven folder.
        </p>
      </div>

      <div class="connection__radio">
        <mat-radio-button
          #fullScope
          color="primary"
          name="dropboxScope"
          data-cy="dropbox-radio2"
          value="full_access"
        ></mat-radio-button>
        <span class="connection__radio-text">
          Full Access
        </span>
        <p class="connection__radio-description">
          Full access to {{ currentConnection.name }} scanning to folders of your choice via OAuth 2.0.
        </p>
        <p class="connection__radio-description">
          Access is only used to read folders and write new scans to selected folders.
        </p>
      </div>
    </mat-radio-group>
  </div>

  <div class="text-center">
    <button
      type="button"
      data-cy="sharepoint-cancel"
      class="button hollow margin-top-2 margin-right-2"
      (click)="navigateToConnectionsPage()"
    >
      Cancel
    </button>

    <button
      type="button"
      data-cy="dropbox-confirm"
      class="button primary margin-top-2"
      (click)="connectService({ service_scope: appScope.checked ? 'app_folder' : 'full_access' })"
    >
      Confirm
    </button>
  </div>
</rav-modal>
